export class SiteSelector {
  private el: HTMLElement;
  private abortController: AbortController;
  private selectField: HTMLSelectElement | null;
  private mobileSiteSelectorLists: NodeListOf<HTMLElement>;

  constructor(el: HTMLElement) {
    this.el = el;
    this.abortController = new AbortController();
    this.selectField = this.el.querySelector<HTMLSelectElement>("select");
    this.mobileSiteSelectorLists = this.el.querySelectorAll<HTMLElement>(
      ".small-down .comp-site-selector-list",
    );
  }

  init(): void {
    const signal = this.abortController.signal;

    if (this.selectField) {
      this.selectField.addEventListener(
        "change",
        () => this.onDropdownChange(),
        { signal },
      );
      this.showSiteSelectorList(this.selectField.value);
    }
  }

  private onDropdownChange(): void {
    if (this.selectField) {
      this.showSiteSelectorList(this.selectField.value);
    }
  }

  private showSiteSelectorList(listId: string): void {
    this.mobileSiteSelectorLists.forEach((list) => {
      list.style.display =
        list.getAttribute("data-list-id") === listId ? "block" : "none";
    });
  }

  destroy(): void {
    this.abortController.abort();
  }

  static initAll(root: Document | HTMLElement = document): void {
    root
      .querySelectorAll<HTMLElement>('[data-component="site-selector"]')
      .forEach((el) => {
        new SiteSelector(el).init();
      });
  }
}
